import { Component } from '@angular/core';
import packageInfo from './../../../../package.json';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-footer',
  imports: [
    DatePipe
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  appVersion: string = packageInfo.version;
  year: number = Date.now();
}
